import { render, staticRenderFns } from "./YoutubeVideoWidget.vue?vue&type=template&id=7f8a9b92&"
import script from "./YoutubeVideoWidget.vue?vue&type=script&lang=js&"
export * from "./YoutubeVideoWidget.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeVideoWidget.vue?vue&type=style&index=0&id=7f8a9b92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports